<template>
    <div class="rowrapper" :style="{'background-image': 'url(' + require('../../assets/img/zbg.jpg') + ')', 'background-size': 'auto', 'background-position': 'center bottom',  'background-repeat': 'no-repeat'}">
      <div class="div1 colwrapper">
        <div class="div3" style="height: 25%; padding: 2rem">
          <a href="https://zingerwallet.com" target="__blank">
            <img alt="Zinger" src="../../assets/img/logos/zingerlong.png" height="80" width="140">
          </a>
        </div>
        <div class="div4" style="height: 75%; padding: 2rem">
          <h3 class="bold-font" style="color: #ffffff;">Upgrade Your Account</h3>
          <h5 class="bold-font" style="color: #ABEBC6;">You have reached your recepient limit (₦2 Million)</h5>
        </div>
      </div>
      <div class="div2 colwrapper">
        <div class="div3" style="height: 25%;"></div>
        <div class="div4" style="height: 75%;">
          <!-- <div class="page"> -->
          <form class="page" @submit.prevent="upgradeb">
            <h5>You will be charged ₦10 ONLY when you receive funds. (i.e. you don't get charged for making payments, topping up, or performing other actions)</h5>
            <Button class="w-50 px-4 py-2 bg-black-5 text-white hover:bg-green-light" round
             style="display: flex; justify-content: center; align-items: center;">
            <span style="text-align: center;" v-if="!isLoading">Upgrade</span>
            <img src="../../assets/img/loaders/spinner.gif" alt="" width="26" height="26" style="text-align: center;" v-if="isLoading">
            </Button> 
          </form>
          <div style="padding-right: 1rem; padding-top: 5rem;">
            <a href="https://zingerwallet.com/terms" target="__blank" id="ahov" style="float: right; color: #82E0AA; font-weight: 300; margin-left: 0.5rem;">Terms</a> 
            <a href="https://zingerwallet.com/privacy" target="__blank" id="ahov2" style="float: right; color: #82E0AA; font-weight: 300; margin-left: 0.5rem;">Privacy <span style="margin-left: 0.3rem;">|</span></a> 
            <a href="https://zingerwallet.com/faqs" target="__blank" id="ahov2" style="float: right; color: #82E0AA; font-weight: 300;">Learn More <span style="margin-left: 0.3rem;">|</span></a> 
          </div> 
        </div>
      </div>
    </div>
</template>

<script>
import router from "../../router";
import Button from "../../components/Button";
// import axios from "axios";
import axios from '../../AxiosInstance.js';

  export default {
    name: 'upgrade',
    components: {
      Button
    },
    data() {
      return{
        url: process.env.VUE_APP_BASE_URL,
        isLoading: false,
        buttonType: 'button',
      }
    },
    created() {
      document.title = "Zinger - Upgrade Account";
    },
    mounted() {
      this.checkLoggedIn();
    },
    methods: {
      checkLoggedIn() {
        if (!this.decrypt(localStorage.getItem("token"))) {
          router.push("/login");
        }else if(this.decrypt(localStorage.getItem("verified_status")) == 'false'){
          router.push("/verify");
        }else if(this.decrypt(localStorage.getItem("reached_limit")) == 'false' || localStorage.getItem("is_business") == 'true' || localStorage.getItem("is_upgraded") == 'true'){
          router.push("/");
        }
      },
      upgradeb(){
        this.isLoading = true;
        let updated_profile = {};
        let self = this;
        updated_profile.is_upgraded = true;
        localStorage.setItem("is_upgraded", true);
        axios.put(this.url + "api/v1/profile/" + self.decrypt(localStorage.getItem("profile_id")) + "/", updated_profile,
        { headers: { authorization: "Token " + self.decrypt(localStorage.getItem("token")) } }).then(response => {
            this.isLoading = false;
            this.$toast.success('Upgrade Successful.', {duration: 3000, position: "top-right"})
            router.push("/");
        }).catch(err => {
            this.isLoading = false;
            this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"})
        });
      },
    }
  }
</script>

<style lang="css" scoped>

.rowrapper{
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-content: stretch;
  padding: 0 100px; 
  padding-top: 80px;
  background: #2ECC71;
}

.div1 {
  width: 100%;
  flex: 1 1 25rem;
}

.div2 {
  width: 100%;
  flex: 1 1 25rem;
}

.div3 {
  width: 100%;
  flex: 1 1 25rem;
}

.div4 {
  width: 100%;
  flex: 1 1 25rem;
}

h1, h2, h3, h4, h5, h6 {
    letter-spacing: -.5px;
    line-height: 1.4;
    margin: 5px 0;
    font-weight: 600;
    font-family: "CW BR Firma",sans-serif;
}

a{
  font-weight: 600;
  font-family: "CW BR Firma",sans-serif;
  color: #2ECC71;
}

#ahov:hover{
  color: #ABEBC6;
}

#ahov2:hover{
  color: #ABEBC6;
}

.bold-font{
  font-weight: 700;
}

h3 {
  font-size: 3rem;
}

h5 {
  font-size: 1.56rem;
}

@media screen and (max-width: 1024px){
  h3 {
    font-size: 1.98rem;
  }
  h5 {
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 600px){
  .rowrapper {
      padding: 20px 20px 80px;
  }
}

.field__input{ 
  --uiFieldPlaceholderColor: var(--fieldPlaceholderColor, #767676);
  color: #ffffff;
  
  background-color: transparent;
  border-radius: 0;
  border: none;

  -webkit-appearance: none;
  -moz-appearance: none;

  font-family: inherit;
  font-size: inherit;
}

.field__input:focus::-webkit-input-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

.field__input:focus::-moz-placeholder{
  color: var(--uiFieldPlaceholderColor);
}

/*
=====
CORE STYLES
=====
*/

.field{
  --uiFieldBorderWidth: var(--fieldBorderWidth, 2px);
  --uiFieldPaddingRight: var(--fieldPaddingRight, 1rem);
  --uiFieldPaddingLeft: var(--fieldPaddingLeft, 1rem);   
  --uiFieldBorderColorActive: var(--fieldBorderColorActive, rgba(22, 22, 22, 1));

  display: var(--fieldDisplay, inline-flex);
  position: relative;
  font-size: var(--fieldFontSize, 1rem);
}

.field__input{
  box-sizing: border-box;
  width: var(--fieldWidth, 100%);
  height: var(--fieldHeight, 3rem);
  padding: var(--fieldPaddingTop, 1.25rem) var(--uiFieldPaddingRight) var(--fieldPaddingBottom, .5rem) var(--uiFieldPaddingLeft);
  border-bottom: var(--uiFieldBorderWidth) solid var(--fieldBorderColor, rgba(0, 0, 0, .25));  
}

.field__input:focus{
  outline: none;
}

.field__input::-webkit-input-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input::-moz-placeholder{
  opacity: 0;
  transition: opacity .2s ease-out;
}

.field__input:focus::-webkit-input-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__input:focus::-moz-placeholder{
  opacity: 1;
  transition-delay: .2s;
}

.field__label-wrap{
  box-sizing: border-box;
  pointer-events: none;
  cursor: text;
  color: #ffffff;

  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.field__label-wrap::after{
  content: "";
  box-sizing: border-box;
  width: 100%;
  height: 0;
  opacity: 0;

  position: absolute;
  bottom: 0;
  left: 0;
}

.field__input:focus ~ .field__label-wrap::after{
  opacity: 1;
}

.field__label{
  position: absolute;
  left: var(--uiFieldPaddingLeft);
  top: calc(50% - .5em);

  line-height: 1;
  font-size: var(--fieldHintFontSize, inherit);

  transition: top .2s cubic-bezier(0.9, -0.15, 0.1, 1.15), opacity .2s ease-out, font-size .2s ease-out;
  will-change: bottom, opacity, font-size;
}

.field__input:focus ~ .field__label-wrap .field__label,
.field__input:not(:placeholder-shown) ~ .field__label-wrap .field__label{
  --fieldHintFontSize: var(--fieldHintFontSizeFocused, .75rem);

  top: var(--fieldHintTopHover, .25rem);
}

/* 
effect 1
*/

.field_v1 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transition: opacity .2s ease-out;
  will-change: opacity;
}

/* 
effect 2
*/

.field_v2 .field__label-wrap{
  overflow: hidden;
}

.field_v2 .field__label-wrap::after{
  border-bottom: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  transform: translate3d(-105%, 0, 0);
  will-change: transform, opacity;
  transition: transform .285s ease-out .2s, opacity .2s ease-out .2s;
}

.field_v2 .field__input:focus ~ .field__label-wrap::after{
  transform: translate3d(0, 0, 0);
  transition-delay: 0;
}

/*
effect 3
*/

.field_v3 .field__label-wrap::after{
  border: var(--uiFieldBorderWidth) solid var(--uiFieldBorderColorActive);
  will-change: opacity, height;
  transition: height .2s ease-out, opacity .2s ease-out;
}

.field_v3 .field__input:focus ~ .field__label-wrap::after{
  height: 100%;
}

/*
=====
LEVEL 4. SETTINGS
=====
*/

.field{
  --fieldBorderColor: #ABEBC6;
  --fieldBorderColorActive: #239B56;
}

/*
=====
DEMO
=====
*/

.page{
  background: transparent; 
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  margin: auto;
  /* padding: 1rem; */

  display: grid;
  grid-gap: 30px;
}
</style>
